<template>
  <wrapper>
    <template slot="before-menu">
      <back-point icon="chevron-left" :to="prevRoute ? { path: prevRoute.fullPath } : 'dashboard'"
        >Alle Events</back-point
      >
    </template>

    <template slot="navigation">
      <menu-point to="event.tickets">Tickets</menu-point>
      <menu-point to="event.information">Informationen</menu-point>
      <menu-point to="event.location">Ort</menu-point>
      <menu-point to="event.organizer">Veranstalter</menu-point>
    </template>

    <template slot="page">
      <router-view :event="event"></router-view>
    </template>
  </wrapper>
</template>


<script>
import MenuPoint from '@/components/MenuPoint';
import Wrapper from '@/components/Wrapper';
import BackPoint from '@/components/BackPoint';

import eventsClient from '@/api/discovery/events';

export default {
  components: {
    MenuPoint,
    BackPoint,
    Wrapper,
  },

  data() {
    return {
      event: {},
      prevRoute: null,
    };
  },

  mounted() {
    eventsClient.show(this.$route.params.id).then((response) => (this.event = response.data.data));
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
};
</script>